import { Vue, Component, Prop, Inject } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { AssaygroupTypeEnum } from '@/api/services/common/assaygroup/common-assaygroup.dto'

@Component
export default class ConfigurationAssaysGroupsModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly assaygroup!: Partial<ConfigurationAssaygroupResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.assaygroup?.id
    }

    get assaygroupTypes(): string[] {
        return Object.keys(AssaygroupTypeEnum)
    }

    constructor() {
        super()

        this.$validator = this.externalValidator
    }
}
